import { NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractDialog, AbstractDialogData, AbstractDialogResultData, AgrDialogModule } from '@next/core-lib/dialog';
import { LocaleService, AgrI18nSharedModule } from '@next/core-lib/i18n';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './delivery-date-help-dialog.component.html',
  imports: [AgrDialogModule, NgFor, AgrI18nSharedModule],
})
export class DeliveryDateHelpDialogComponent extends AbstractDialog<AbstractDialogData> {
  public readonly helpText = [
    {
      title: this.localeService.translate('cart.cart-order-type.RushOrder'),
      description: this.localeService.translate('cart.cart-delivery-date-help-modal.RushOrder.description'),
    },
    {
      title: `${this.localeService.translate(
        'cart.cart-order-type.EmergencyOrder',
      )} (${this.localeService.translate('cart.cart-help-modal.EmergencyOrder.delivery-time')})`,
      description: this.localeService.translate('cart.cart-delivery-date-help-modal.EmergencyOrder.description'),
    },
  ];

  constructor(
    protected mdDialogRef: MatDialogRef<DeliveryDateHelpDialogComponent, AbstractDialogResultData<AbstractDialogData>>,
    @Inject(MAT_DIALOG_DATA) public data: AbstractDialogData,
    private readonly localeService: LocaleService,
  ) {
    super();
  }
}
